import { officeDisplays } from "../catalog/office.ts";
import { matchPattern } from "../match-pattern.ts";
import { decodeSegment } from "./decode-segment.ts";
import type { MatchCandidate } from "./matched-route.ts";
import { areasByBucket, definitions } from "./route-definitions.ts";

const officeDisplayNames: ReadonlySet<string> = new Set(officeDisplays);

function matchPolicyVersion(raw: readonly string[]): MatchCandidate {
  const version = raw[1]?.match(/^(.*):v(-?\d+(?:\.\d+)?)$/);
  const encodedName = version?.[1];
  const versionNumber = version?.[2];

  if (encodedName === undefined || versionNumber === undefined) return {};

  return {
    policyName: decodeSegment(encodedName),
    version: Number(versionNumber),
  };
}

export function matchStaticRoute({
  parts,
  raw,
}: {
  readonly parts: readonly string[];
  readonly raw: readonly string[];
}): MatchCandidate | null {
  for (const [name, definition] of definitions) {
    if (definition.scope === "game" || name === "episodeReplay") continue;

    const params = matchPattern({
      pattern: definition.path.split("/").filter(Boolean),
      parts,
    });

    if (!params) continue;

    if (
      name === "office.display" &&
      (typeof params.display !== "string" ||
        !officeDisplayNames.has(params.display))
    )
      continue;

    const match = {
      name,
      ...params,
      area: areasByBucket[definition.bucket],
      section: null,
      bucket: definition.bucket,
      entry: definition.entry,
      disposition: definition.disposition,
    };

    if (name === "policy") return { ...match, ...matchPolicyVersion(raw) };

    return match;
  }

  return null;
}
